/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Defaulttitle1Inputs */

const zh_chat_defaulttitle1 = /** @type {(inputs: Chat_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话 - StudyOS`)
};

const en_chat_defaulttitle1 = /** @type {(inputs: Chat_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation - StudyOS`)
};

const es_chat_defaulttitle1 = /** @type {(inputs: Chat_Defaulttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversación - StudyOS`)
};

/**
* | output |
* | --- |
* | "Conversation - StudyOS" |
*
* @param {Chat_Defaulttitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_defaulttitle1 = /** @type {((inputs?: Chat_Defaulttitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Defaulttitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_defaulttitle1(inputs)
	if (locale === "en") return en_chat_defaulttitle1(inputs)
	return es_chat_defaulttitle1(inputs)
});
export { chat_defaulttitle1 as "chat_defaultTitle" }